export function isTextElement(node) {
    return (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement);
}
export function isFormControlElement(node) {
    return (node instanceof HTMLInputElement ||
        node instanceof HTMLTextAreaElement ||
        node instanceof HTMLSelectElement);
}
/* This function checks the node if it has an attribute `data-suf-ignore`
  It's used to ignore elements that should not be part of the form
*/
export function isIgnoredElement(node) {
    return ((node.hasAttribute("data-suf-ignore") &&
        node.getAttribute("data-suf-ignore") === "true") || // <div data-suf-ignore="true">
        node.getAttribute("data-suf-ignore") === true // <div data-suf-ignore> or <div data-suf-ignore={true}>
    );
}
